import { render, staticRenderFns } from "./DialogCustomerVerify.vue?vue&type=template&id=0275f859"
import script from "./DialogCustomerVerify.vue?vue&type=script&lang=js"
export * from "./DialogCustomerVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports